<template>
  <nav class="nested-menu" aria-label="mobile-menu">
    <transition name="parent-level-animation">
      <ul v-if="!selectedParent" class="parent-level">
        <li v-for="(item, index) in menu" :key="index">
          <button
            v-if="item.children.length"
            class="mobile-menu__button"
            @click="selectedParent = item"
          >
            {{ item.title }}
            <svg class="icon"><use href="#arrow-right-long" /></svg>
          </button>
          <a v-else :href="item.url" class="mobile-menu__button">
            {{ item.title }}
          </a>
        </li>
      </ul>
    </transition>

    <transition name="child-level-animation">
      <ul v-if="selectedParent" ref="child-level" class="child-level">
        <button class="title" @click="selectedParent = null">
          <svg class="icon"><use href="#chevron-left" /></svg>
          {{ selectedParent.title }}
        </button>
        <li
          v-for="(item, index) in selectedParent.children"
          :key="index"
          ref="child"
          class="childrens"
        >
          <button
            v-if="item.children.length"
            :class="{
              'is-active': selectedChildIndex == index,
            }"
            class="mobile-menu__button"
            @click="toggleSelectedChildIndex(index)"
          >
            {{ item.title }}
            <svg class="icon plus"><use href="#plus" /></svg>
            <svg class="icon minus"><use href="#minus" /></svg>
          </button>
          <a v-else :href="item.url" class="mobile-menu__button">
            {{ item.title }}
          </a>

          <transition
            name="slidedown"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
          >
            <ul
              v-if="item.children.length"
              v-show="selectedChildIndex == index"
              ref="sub-items"
              class="sub-items"
            >
              <li v-for="(subItem, i) in item.children" :key="i">
                <a :href="subItem.url" class="sub-item">
                  {{ subItem.title }}
                </a>
              </li>
            </ul>
          </transition>
        </li>
      </ul>
    </transition>
  </nav>
</template>

<script>
export default {
  props: {
    menu: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      selectedParent: null,
      selectedChildIndex: null,
    };
  },

  methods: {
    toggleSelectedChildIndex(index) {
      if (this.selectedChildIndex === index) {
        this.selectedChildIndex = null;
        return;
      }
      this.selectedChildIndex = index;

      const childLevel = this.$refs['child-level'];
      const childOffsetTop = this.$refs.child[index].offsetTop;

      if (childLevel.offsetHeight - childOffsetTop < 100) {
        setTimeout(() => {
          childLevel.scrollTo({
            top: childOffsetTop,
            behavior: 'smooth',
          });
        }, 150);
      }
    },

    beforeEnter(el) {
      el.style.height = '0';
    },

    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    leave(el) {
      el.style.height = '0';
    },
  },
};
</script>
